import { render, staticRenderFns } from "./TemplateSelectionSavedPanel.vue?vue&type=template&id=1a3c8eb2&scoped=true"
import script from "./TemplateSelectionSavedPanel.vue?vue&type=script&lang=js"
export * from "./TemplateSelectionSavedPanel.vue?vue&type=script&lang=js"
import style0 from "./TemplateSelectionSavedPanel.vue?vue&type=style&index=0&id=1a3c8eb2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a3c8eb2",
  null
  
)

export default component.exports